import React from 'react';

const AuthBackground = () => (
    <div className="auth_background">
        <div className="bg_box">
            <h1>From Static to Smart</h1>
            <p>Unlocking SCORM for the AI era</p>
        </div>
    </div>
);

export default AuthBackground;
